import {
  DASHBOARD_QUICK_ORDER_CLONE_FAIL,
  DASHBOARD_QUICK_ORDER_CLONE_REQUEST,
  DASHBOARD_QUICK_ORDER_CLONE_RESET,
  DASHBOARD_QUICK_ORDER_CLONE_SUCCESS,
  DASHBOARD_QUICK_ORDER_CREATE_QUOTE_FAIL,
  DASHBOARD_QUICK_ORDER_CREATE_QUOTE_REQUEST,
  DASHBOARD_QUICK_ORDER_CREATE_QUOTE_RESET,
  DASHBOARD_QUICK_ORDER_CREATE_QUOTE_SUCCESS,
  DASHBOARD_QUICK_ORDER_FAV_QUOTES_FAIL,
  DASHBOARD_QUICK_ORDER_FAV_QUOTES_REQUEST,
  DASHBOARD_QUICK_ORDER_FAV_QUOTES_SUCCESS,
  DASHBOARD_QUICK_ORDER_GET_HEADER_FAIL,
  DASHBOARD_QUICK_ORDER_GET_HEADER_REQUEST,
  DASHBOARD_QUICK_ORDER_GET_HEADER_RESET,
  DASHBOARD_QUICK_ORDER_GET_HEADER_SUCCESS,
  DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_FAIL,
  DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_REQUEST,
  DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_RESET,
  DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_SUCCESS,
  DASHBOARD_QUICK_ORDER_RECENT_ORDERS_FAIL,
  DASHBOARD_QUICK_ORDER_RECENT_ORDERS_REQUEST,
  DASHBOARD_QUICK_ORDER_RECENT_ORDERS_SUCCESS
} from '@/constants/dashboardQuickOrderConstants'

export const dashboardQuickOrderCreateQuoteReducer = (state = { loading: false, quoteNo: null, error: null }, action) => {
  switch (action.type) {
    case DASHBOARD_QUICK_ORDER_CREATE_QUOTE_REQUEST:
      return { ...state, loading: true, error: null }
    case DASHBOARD_QUICK_ORDER_CREATE_QUOTE_SUCCESS:
      return { loading: false, quoteNo: action.payload, error: null }
    case DASHBOARD_QUICK_ORDER_CREATE_QUOTE_FAIL:
      return { loading: false, quoteNo: null, error: action.payload }
    case DASHBOARD_QUICK_ORDER_CREATE_QUOTE_RESET:
      return { loading: false, quoteNo: null, error: null }
    default:
      return state
  }
}

const lineItemsInitialState = { loading: false, items: [], total: 0, page: 0, pages: 0, hasNext: false, error: null }

export const dashboardQuickOrderLineItemsReducer = (state = lineItemsInitialState, action) => {
  switch (action.type) {
    case DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_REQUEST:
      return { ...state, loading: true, error: null }
    case DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_SUCCESS: {
      const { items, total, next_page, pages, has_next } = action.payload
      return {
        loading: false,
        items: state.page === 0 ? items : [...state.items, ...items],
        total,
        page: next_page ? next_page - 1 : pages,
        pages,
        hasNext: has_next,
        error: null
      }
    }
    case DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DASHBOARD_QUICK_ORDER_GET_LINE_ITEMS_RESET:
      return lineItemsInitialState
    default:
      return state
  }
}

const recentOrdersInitialState = { loading: false, orders: [], hasNext: false, page: 0, error: null }

export const dashboardQuickOrderRecentOrdersReducer = (state = recentOrdersInitialState, action) => {
  switch (action.type) {
    case DASHBOARD_QUICK_ORDER_RECENT_ORDERS_REQUEST:
      return { ...state, loading: true, error: null, ...(action.payload?.page === 1 || !action.payload ? { orders: [] } : {}) }
    case DASHBOARD_QUICK_ORDER_RECENT_ORDERS_SUCCESS: {
      const items = action.payload?.items || action.payload?.results || []
      const page = action.payload?.page || 1
      return {
        loading: false,
        orders: page === 1 ? items : [...state.orders, ...items],
        hasNext: action.payload?.has_next || false,
        page,
        error: null
      }
    }
    case DASHBOARD_QUICK_ORDER_RECENT_ORDERS_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

const favQuotesInitialState = { loading: false, orders: [], hasNext: false, page: 0, error: null }

export const dashboardQuickOrderFavQuotesReducer = (state = favQuotesInitialState, action) => {
  switch (action.type) {
    case DASHBOARD_QUICK_ORDER_FAV_QUOTES_REQUEST:
      return { ...state, loading: true, error: null, ...(action.payload?.page === 1 || !action.payload ? { orders: [] } : {}) }
    case DASHBOARD_QUICK_ORDER_FAV_QUOTES_SUCCESS: {
      const items = action.payload?.items || action.payload?.results || []
      const page = action.payload?.page || 1
      return {
        loading: false,
        orders: page === 1 ? items : [...state.orders, ...items],
        hasNext: action.payload?.has_next || false,
        page,
        error: null
      }
    }
    case DASHBOARD_QUICK_ORDER_FAV_QUOTES_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const dashboardQuickOrderCloneReducer = (state = { loading: false, quoteNo: null, error: null }, action) => {
  switch (action.type) {
    case DASHBOARD_QUICK_ORDER_CLONE_REQUEST:
      return { ...state, loading: true, error: null }
    case DASHBOARD_QUICK_ORDER_CLONE_SUCCESS:
      return { loading: false, quoteNo: action.payload, error: null }
    case DASHBOARD_QUICK_ORDER_CLONE_FAIL:
      return { loading: false, quoteNo: null, error: action.payload }
    case DASHBOARD_QUICK_ORDER_CLONE_RESET:
      return { loading: false, quoteNo: null, error: null }
    default:
      return state
  }
}

export const dashboardQuickOrderHeaderReducer = (state = { loading: false, header: null, error: null }, action) => {
  switch (action.type) {
    case DASHBOARD_QUICK_ORDER_GET_HEADER_REQUEST:
      return { ...state, loading: true, error: null }
    case DASHBOARD_QUICK_ORDER_GET_HEADER_SUCCESS:
      return { loading: false, header: action.payload, error: null }
    case DASHBOARD_QUICK_ORDER_GET_HEADER_FAIL:
      return { loading: false, header: null, error: action.payload }
    case DASHBOARD_QUICK_ORDER_GET_HEADER_RESET:
      return { loading: false, header: null, error: null }
    default:
      return state
  }
}
